module.exports = __webpack_public_path__ + "img/CAL-IEC-Case.395b4e19.png";